import { Category, CategoryLabel } from './categories.model';
import { ActiveState, EntityState, EntityStore, StoreConfig, ID } from '@datorama/akita';
import { Injectable } from '@angular/core';

export interface CategoriesState extends EntityState<Category, ID>, ActiveState {
    activeLinkingLabel: CategoryLabel;
    ui: {
        [key: string]: {
            isLoading: boolean;
        };
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'categories', cache: { ttl: 3600000 }, idKey: 'id' })
export class CategoriesStore extends EntityStore<CategoriesState> {
    constructor() {
        super();
    }
}
